import React from "react";
import { useSelector } from "react-redux";
import SEO from "@/components/SEO";
import NoMatch from "@/Pages/NoMatch";

import CreateHubStepOne from "./createHubStepOne";
import CreateHubStepTwo from "./createHubStepTwo";

interface CreateHubProps {
  params: { h_id?: string; step?: string };
}

const CreateHub = ({ params }: CreateHubProps) => {
  const isStart = params.h_id === "start";

  // Selected as a single boolean: useSelector compares by reference, so
  // returning an object here would re-render on every dispatched action,
  // where the previous connect() shallow-compared.
  const hubExists = useSelector((state: any) => {
    const { hubs, invitations } = state;
    const isValid = Boolean(
      invitations.createHubInvitations.find(
        (chi: any) => chi.get("token") === invitations.createHubInvitationToken
      )
    );
    return (
      isValid ||
      Boolean(
        hubs.userHubs.find(
          (h: any) => h.get("id") === parseInt(params.h_id ?? "", 10)
        )
      )
    );
  });

  if (!hubExists) return <NoMatch />;

  if (isStart) {
    return (
      <SEO title="Create your hub">
        <CreateHubStepOne />
      </SEO>
    );
  }

  switch (params.step) {
    case "step-one":
      return (
        <SEO title="Create your hub">
          <CreateHubStepOne />
        </SEO>
      );
    case "step-two":
      return (
        <SEO title="Create your hub">
          <CreateHubStepTwo />
        </SEO>
      );
    default:
      return <NoMatch />;
  }
};

export default CreateHub;
